export const featureName = 'supplier';

export interface ISuppliersResponse {
  totalElements: number;
  totalPages: number;
  pageable: {
    sort: {
      sorted: boolean;
      empty: boolean;
      unsorted: boolean;
    };
    pageNumber: number;
    pageSize: number;
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  content: IResSupplierItemContent[];
}

export type GetSupplierListParams = {
  page: number;
  size: number;
  keySearch: string;
};
export type ICreateOrUpdateSupplierBody = {
  id?: string;
  name: string;
  phone: string;
  email: string;
  description?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  website?: string;
};

export type IResSupplierItemContent = {
  id: string;
  name: string;
  code: string | null;
  email: string;
  phone: string;
  active: boolean;
  address: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  description: string | null;
  website: string | null;
  lastOrderDate: string | null;
  totalProducts: number;
  quantity: number;
  totalSold: number;
  inventory: number;
  totalPrice: number;
};

export const SUPPLIER_PAGE_SIZE = 10;
